import {Component} from '@angular/core';
import {AuthCard} from "@components/layout/auth/auth-card/auth-card";

@Component({
    selector: 'app-no-permission',
    imports: [
        AuthCard
    ],
    templateUrl: './no-permission.html',
    styleUrl: './no-permission.css'
})
export class NoPermission {

}
